// This file is updated with the version on build
// Don't edit unless you are sure what you are doing
import { WindowKeys } from "@omni/services/windowManagement";
import * as WindowManagement from "@omni/services/windowManagement";

WindowManagement.saveObject(WindowKeys.VERSION, "18.0.5");
